module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/masters/district/district-grid/district-grid.component.css
// module id = ./src/app/masters/district/district-grid/district-grid.component.css
// module chunks = main